module.exports = __webpack_public_path__ + "static/media/14 - Clap 2.65f6c3f7.wav";